import models from 'plugins/i18n/modelTypes.en.ts'

export default {
	activityFeed: {
		title: 'Activities / Updates',
		from: 'from',
		created: 'created',
		edited: 'edited',
		search: 'Search history',
		noMatches: 'No entries match your search.',
		field_updated: '{field} was updated from {from} to {to}',
		groups: {
			all: 'All',
			comments: 'Comments / e-mails',
			status: 'Status',
			persons: 'People',
			links: 'Links',
			documents: 'Documents',
			data: 'Task / report data',
			other: 'Other',
		},
		reply: 'Reply',
		systemUpdate: 'System update',
		model: { ...models },
	},
}
